<template>
  <section>
    <footer class="bg-dark text-white py-5">
      <div class="col-md-10 mx-auto px-3">
        <div class="row">
          <div class="col-md-4">
            <img
              src="https://ventusleasing.mx/wp-content/uploads/2023/04/Logotipo-Ventus-Leasing-Arrendamiento-Puro-Financiamiento-Activos-1-1.png"
              width="170"
              class="py-4"
            />
          </div>
          <div class="col-md-4 px-3">
            <div class="footer-header">
              <h5 class="text-white">Compañía</h5>
            </div>
            <ul class="ps-0" style="list-style: none">
              <li class="mb-1 mt-2">
                <a href="https://ventusleasing.mx/nosotros/" target="_blank">
                  Nosotros
                </a>
              </li>
              <li class="mb-1">
                <a href="https://ventusleasing.mx/productos/" target="_blank">
                  Productos
                </a>
              </li>
              <li class="mb-1">
                <a href="https://ventusleasing.mx/clientes/" target="_blank">
                  Clientes
                </a>
              </li>
              <li class="mb-1">
                <a href="https://ventusleasing.mx/contacto/" target="_blank">
                  Contacto
                </a>
              </li>
              <li class="mb-1">
                <a href="https://ventusleasing.mx/blog/" target="_blank">
                  Blog
                </a>
              </li>
              <li class="mb-1">
                <a
                  href="https://ventusleasing.mx/preguntas-frecuentes/"
                  target="_blank"
                >
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
            <div class="d-flex">
              <i class="la la-instagram"></i>
              <i class="la la-instagram"></i>
              <i class="la la-instagram"></i>
            </div>
            <div></div>
          </div>
          <div class="col-md-4 px-3">
            <div class="footer-header">
              <h5 class="text-white">Atención a cliente</h5>
            </div>
            <p class="mt-2">comercial@ventus.mx</p>

            <span class="text-xs">MONTERREY</span>
            <p>
              Av. Lázaro Cárdenas 303, int. 2, Col. Del Valle. C.P: 66220.
              <br />
              San Pedro Garza García, N.L.
            </p>

            <span class="text-xs">TORREON</span>
            <p>
              San Pedro de las Colonias 2200<br />
              Torreón, Coah.
            </p>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mt-4">
          <p class="text-xs">
            Derechos Reservados {{ new Date().getFullYear() }}
          </p>
          <u><a href="#" class="text-white text-xs">Aviso de privacidad</a></u>
        </div>
      </div>
    </footer>
  </section>
</template>

<style scoped>
a {
  color: #fff;
}

a:hover {
  color: #efc233;
}
</style>
